import React, { useState } from "react";
import { Image as ImageIcon } from "lucide-react";
import { Button } from "../ui/button";
import { OrderAssets } from "./OrderAssets";
import { PdfPreview } from "./PdfPreview";

export function OrderProjectInfo({ o }) {
  const [showProof, setShowProof] = useState(false);
  return (
    <div className="text-sm">
      <div className="uppercase text-[10px] tracking-[0.25em] text-[color:var(--text-muted)]">Project</div>
      <div className="mt-1" style={{color: "var(--primary)"}}>{o.tier === "custom-quote" ? "Custom quote" : o.tier} · {o.material}</div>
      {o.complexity && <div className="text-xs text-[color:var(--text-muted)]">Complexity: {o.complexity} · Deadline: {o.desired_deadline || "flexible"}</div>}
      <div className="mt-2 text-xs leading-relaxed">{o.description}</div>
      <div className="mt-3 text-xs text-[color:var(--text-muted)]">Ship to: {o.shipping_address}</div>
      {o.design_preview_image && (
        <div className="mt-3" data-testid={`design-preview-${o.order_id}`}>
          <div className="uppercase text-[10px] tracking-[0.25em] text-[color:var(--text-muted)] mb-1"><ImageIcon size={10} className="inline mr-1"/>Customer's design preview</div>
          <img src={o.design_preview_image} alt="customer design preview" className="max-w-full rounded border hairline bg-white"/>
        </div>
      )}
      {o.asset_count > 0 && <OrderAssets orderId={o.order_id}/>}
      {o.quote_amount && (
        <div className="mt-3 text-sm" style={{color: "var(--primary)"}}>
          Quote: <b>${(o.quote_amount/100).toFixed(2)}</b>
          {o.military_discount_amount ? <span className="text-[color:var(--text-muted)]"> − ${(o.military_discount_amount/100).toFixed(2)} military = <b>${((o.quote_amount_after_discount || o.amount)/100).toFixed(2)}</b></span> : null}
        </div>
      )}
      {o.military_discount && o.military_proof_submitted && (
        <Button data-testid={`view-proof-${o.order_id}`} variant="outline" size="sm" className="mt-3 rounded-full" onClick={() => setShowProof((s) => !s)}>
          <ImageIcon size={12} className="mr-2"/>{showProof ? "Hide proof" : "View proof"}
        </Button>
      )}
      {showProof && o.military_proof_data && (
        <div className="mt-3" data-testid={`proof-view-${o.order_id}`}>
          {o.military_proof_data.startsWith("data:application/pdf") ? (
            <PdfPreview dataUrl={o.military_proof_data} orderId={o.order_id}/>
          ) : (
            <img src={o.military_proof_data} alt="military proof" data-testid={`proof-img-${o.order_id}`} className="max-w-full rounded border hairline"/>
          )}
          {o.military_proof_note && <div className="text-xs text-[color:var(--text-muted)] mt-2">Note: {o.military_proof_note}</div>}
        </div>
      )}
    </div>
  );
}
